function newsSlider() {
  $(document).ready(function() {
    if ($('.view-display-id-news_block').length) {
      var newsSlider = new Splide('#news_slider', {
        type: 'loop',
        perPage: 5,
        perMove: 5,
        focus: 'center',
        autoplay: true,
        arrows: true,
        pagination: false,
        drag: true,
        trimSpace: true,
        gap: "0.6rem",

        breakpoints: {
          600: {
            perPage: 1,
            perMove: 1,
          },
          1024: {
            perPage: 2,
            perMove: 2,
            focus: 'left',
            gap: "0.4rem",
          },
          1200: {
            perPage: 3,
            perMove: 3,
            gap: "0.4rem",
          },
          1300: {
            perPage: 4,
            perMove: 4,
            focus: 'left',
            gap: "0.5rem",
          },
          1400: {
            perPage: 4,
            perMove: 4,
            focus: 'left',
          },
          1500: {
            perPage: 5,
            perMove: 5,
          },
        }
      });

      newsSlider.mount();
    }

    if ($('.view-display-id-news_related_block').length) {
      var newsRelatedSlider = new Splide('#news_related_slider', {
        type: 'loop',
        perPage: 5,
        perMove: 5,
        autoplay: true,
        arrows: true,
        pagination: false,
        drag: true,
        trimSpace: true,
        gap: "0.6rem",

        breakpoints: {
          600: {
            perPage: 1,
            perMove: 1,
          },
          1024: {
            perPage: 2,
            perMove: 2,
            gap: "0.4rem",
          },
          1200: {
            perPage: 3,
            perMove: 3,
            gap: "0.4rem",
          },
          1300: {
            perPage: 4,
            perMove: 4,
            gap: "0.5rem",
          },
          1400: {
            perPage: 4,
            perMove: 4,
          },
          1500: {
            perPage: 5,
            perMove: 5,
          },
        }
      });

      newsRelatedSlider.mount();
    }
  });
}
